<template>
  <div :class="componentClasses" @click="toggleCheckbox">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8">
      <path
        class="checkmark"
        d="M4 0c-1.099 0-2 .901-2 2v1h-1v4h6v-4h-1v-1c0-1.099-.901-2-2-2zm0 1c.561 0 1 .439 1 1v1h-2v-1c0-.561.439-1 1-1z"
        fill="#000000"
      ></path>
    </svg>

    <input
      :disabled="disabled"
      type="checkbox"
      v-bind:checked="boxChecked"
      v-on:change="updateChecked"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      boxChecked: false
    };
  },
  model: {
    prop: "checked",
    event: "change"
  },
  props: ["checked", "disabled"],
  watch: {
    checked: {
      handler(val) {
        this.boxChecked = this.checked && this.checked != "0" ? true : false;
      }
    }
  },
  computed: {
    componentClasses: function() {
      if (this.boxChecked) {
        return "checkbox checked";
      }
      return "checkbox";
    },
    getToolTip: function() {
      return this.boxChecked ? "Haal dienst van slot" : "Zet dienst op slot";
    }
  },
  methods: {
    toggleCheckbox: function() {
      if (this.disabled) {
        return;
      }
      this.boxChecked = !this.boxChecked;
      this.updateChecked();
    },
    updateChecked() {
      // console.log('updated ' + this.boxChecked);
      this.$emit("change", this.boxChecked);
    }
  },
  mounted() {
    // console.log('Checkbox component mounted.')
    // console.log(this.$el.clientHeight);
    // this.$el.clientWidth = this.$el.clientHeight;
  },
  created() {
    // console.log('Checkbox component created.');
    this.boxChecked = this.checked && this.checked != "0" ? true : false;
  }
};
</script>

<style scoped>
.checkbox {
  border: 1px solid #000;
  width: 15px;
  height: 15px;
  padding: 2px;
  margin: 0;
  display: inline-grid;
  vertical-align: top;
}

.checkbox:hover {
  cursor: pointer;
}

.checkbox input,
.checkbox svg {
  display: none;
}

.checkbox.checked svg {
  display: inline-block;
}

.checkbox .checkmark {
  fill: #666666;
}
</style>
